var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"brands responsive-menu"},[_c('div',{staticClass:"responsive-menu__child"},[_c('PageHeader',{attrs:{"pageHeader":_vm.listPageHeader,"links":[
      { name: 'home', label: 'Home' },
      { name: 'brands', label: 'Brands' } ],"entity":_vm.entity}}),_c('SearchTable',{attrs:{"entity":_vm.entity,"filter":{
      isDeleted: false
    }}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }